<template>
<div class="flex h-full items-center">
  <div
    style="margin: 0; padding: 0; height: 38px; font-size: 13px;"
    class="flex justify-center items-center cstm-status-badge w-full"
    :class="params.data.process_success_status.toLowerCase()"
  >
    {{ params.data.process_success_status }}
  </div>
</div>
</template>

<script>
export default {
  name: 'StatusCell'
}
</script>